/**
 * 管理员仪表盘 — 统计总览
 */
import React, { useEffect, useState } from 'react';
import { adminApi } from '../../services/adminApi';
import { AdminStats } from '../../types';
import { UsersIcon, DocumentTextIcon, BoltIcon, ChartBarIcon } from '@heroicons/react/24/outline';

const AdminDashboard: React.FC = () => {
  const [stats, setStats] = useState<AdminStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    adminApi.getStats()
      .then((res) => setStats(res.data.data || res.data))
      .catch(() => setError('加载失败'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center py-16 text-slate-400">加载中...</div>;
  if (error) return <div className="p-4 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm">{error}</div>;
  if (!stats) return null;

  const cards = [
    { label: '总用户数', value: stats.total_users, icon: UsersIcon, color: 'bg-blue-500' },
    { label: '活跃用户', value: stats.active_users, icon: UsersIcon, color: 'bg-emerald-500' },
    { label: '项目总数', value: stats.total_projects, icon: DocumentTextIcon, color: 'bg-violet-500' },
    { label: '生成任务', value: stats.total_tasks, icon: BoltIcon, color: 'bg-amber-500' },
    { label: '模板数量', value: stats.total_templates, icon: ChartBarIcon, color: 'bg-rose-500' },
    { label: '平均字数', value: Number(stats.avg_word_count || 0).toFixed(0), icon: ChartBarIcon, color: 'bg-cyan-500' },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-slate-800">统计总览</h2>
          <p className="text-sm text-slate-500 mt-0.5">平台运行关键指标</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map(card => (
          <div key={card.label} className="bg-white rounded-xl shadow-sm border border-slate-100 p-5 hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between mb-3">
              <span className="text-sm text-slate-500 font-medium">{card.label}</span>
              <div className={`w-8 h-8 ${card.color} rounded-lg flex items-center justify-center`}>
                <card.icon className="w-4 h-4 text-white" />
              </div>
            </div>
            <p className="text-2xl font-bold text-slate-800">{card.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
